<template>
  <portal to="modals">
    <div class="fixed inset-0 z-50 overflow-y-auto" v-if="showModal">
      <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 sm:block sm:p-0">
        <transition
          @before-leave="backdropLeaving = true"
          @after-leave="backdropLeaving = false"
          enter-active-class="transition duration-300 ease-out-quad"
          leave-active-class="transition duration-200 ease-in-quad"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
          appear>
          <div class="fixed inset-0 transition-opacity" v-if="showBackdrop" @click="close">
            <div class="absolute inset-0 bg-gray-900 opacity-75"></div>
          </div>
        </transition>

        <transition
          @before-leave="cardLeaving = true"
          @after-leave="cardLeaving = false"
          enter-active-class="transition duration-300 ease-out-quad"
          leave-active-class="transition duration-200 ease-in-quad"
          enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
          enter-to-class="translate-y-0 opacity-100 sm:scale-100"
          leave-class="translate-y-0 opacity-100 sm:scale-100"
          leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
          appear>
          <div class="w-full mx-auto align-bottom transition transform bg-white rounded-lg shadow-xl sm:align-middle sm:my-8" :class="size" role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-if="showContent">
            <div class="flex items-center px-6 py-5 justify-betewen" v-if="title">
              <div class="pr-4 text-lg font-bold">
                {{ title }}
              </div>
              <button @click="close" class="ml-auto text-xl text-gray-800 hover:text-gray-400">
                &#10005;
              </button>
            </div>
            <slot />
          </div>
        </transition>
      </div>
    </div>
  </portal>
</template>

<script>
  export default {
    name: 'Modal',

    created () {
      const onEscape = (e) => {
        if (this.open && e.keyCode === 27) {
          this.close()
        }
      }
      document.addEventListener('keydown', onEscape)
      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', onEscape)
      })
    },

    props: {
      open: {
        type: Boolean,
        default: false
      },

      title: {
        type: String
      },

      size: {
        type: String,
        default: 'sm:max-w-lg'
      }
    },

    computed: {
      leaving () {
        return this.backdropLeaving || this.cardLeaving
      }
    },

    data() {
      return {
        showModal: false,
        showBackdrop: false,
        showContent: false,
        backdropLeaving: false,
        cardLeaving: false,
      }
    },

    methods: {
      show () {
        this.showModal = true
        this.showBackdrop = true
        this.showContent = true
      },

      close () {
        this.showBackdrop = false
        this.showContent = false
        this.$emit('update:open', false)
        this.$emit('close')
      }
    },

    watch: {
      open: {
        handler: function (newValue) {
          if (newValue) {
            this.show()
          } else {
            this.close()
          }
        },
        immediate: true
      },

      leaving (newValue) {
        if (newValue === false) {
          this.showModal = false
          this.$emit('close')
        }
      }
    }
  }
</script>